"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUM_REWARDS = void 0;
// The number of rewards supported by this whirlpool.
exports.NUM_REWARDS = 3;
